import React from "react";

export default function AboutPage() {
	return (
		<div className="container p-5">
			<h5>Hakkımızda Alanı</h5>
		</div>
	);
}
